import React from 'react';
import { Box, Typography } from '@mui/material';
import { Student } from '../../store/slices/studentSlice';

interface WelcomeSectionProps {
  selectedStudent: Student;
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({ selectedStudent }) => {
  return (
    <Box sx={{ mb: 4, p: 3, bgcolor: '#f8f9fa', borderRadius: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" sx={{ color: '#1E232C' }}>
          Welcome back, {selectedStudent.name.split(' ')[0]}!
        </Typography>
      </Box>
    </Box>
  );
};

export default WelcomeSection;